var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticStyle:{"overflow":"scroll"},attrs:{"color":_vm.color,"dark":""}},[_c('v-card-text',[_c('pre',{style:({fontSize: `${_vm.fontSize}pt`}),domProps:{"innerHTML":_vm._s(_vm.formatedValue)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }